import styled from "styled-components";

export const TopHeader = styled.header`
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 64.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 101;
  padding: 0 0;
  background-color: rgba(0,0,0,0.3);
  @media screen and (max-width: 992px) {
    background-color: transparent;
  }
`;

export const CellImageUp = styled.img`
    @media only screen and (min-width: 768px) {
      display: none;
    }
    @media only screen and (max-width: 768px) {
        position: fixed;
        transform: matrix(1, 0, 0, -1, 0, 0);
        top: -145px;
        right: -70px;
        width: 239px;
        z-index: -1;
        opacity: 0.9;
    }
`;

export const HeaderElementsContainer = styled.div`
  width: 100%;
  max-width: 1084px;
  height: 64.5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;

  @media only screen and (min-width: 992px) {
    width: 804px;
  }

  @media only screen and (min-width: 1200px) {
    width: 1084px;
  }
  
`